<template>
  <div class="text-xs-center">
    <v-dialog persistent v-model="dialog" max-width="500" :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card dark class="flexcard">
        <v-toolbar>
          <v-toolbar-title>
            {{customText}}
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="grow">
          <span class="subheading font-weight-regular">{{customText}}</span>
          <br>
          {{hotspotDescription}}
          <br>
          <v-list v-if="attachments">
            <v-list-tile
              v-for="item in attachments"
              :key="item.title"
              @click="select(item)"
            >
              <v-list-tile-action>
                <v-icon v-if="item.icon" color="blue">{{item.icon}}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>
                  <span class="blue--text body-1">{{item.title}}</span>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat icon @click.stop="close">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </div>
</template>

<script>
/* eslint func-names: ["error", "never"] */
/* eslint object-shorthand: 0 */

export default {
  name: 'HotspotDialog',
  props: {
    dialog: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    customText() {
      return this.dialog.customText || '';
    },
    hotspotDescription() {
      return this.dialog.hotspotDescription || '';
    },
    attachments() {
      const items = this.dialog.attachments;
      if (items) {
        const attachments = items.map((item) => {
          const obj = {};
          if (typeof item === 'string') {
            obj.title = item;
          } else if (typeof item === 'object') {
            obj.title = Object.keys(item)[0];
            obj.id = Object.values(item)[0];
          }

          let suffix;
          if (typeof item === 'string') {
            suffix = item.substring(item.lastIndexOf('.') + 1);
          } else if (typeof item === 'object') {
            suffix = Object.keys(item)[0].split('.').pop();
          }
          switch (suffix) {
            case 'pdf':
              obj.icon = 'picture_as_pdf';
              break;
            case 'mp4':
              obj.icon = 'videocam';
              break;
            case 'png':
            case 'jpg':
            case 'jpeg':
              obj.icon = 'image';
              break;
            default:
              obj.icon = 'attach_file';
          }
          return obj;
        });
        return attachments;
      }
      return null;
    },
  },
  methods: {
    close() {
      this.$store.commit('currentHotspot', null);
    },
    select(item) {
      const ts = Date.now();
      let url = '';
      if (item.id) {
        const { attachments } = this.$store.state.project;
        url = attachments.filter(attachment => Object.keys(attachment)[0] === item.id)[0][item.id];
        // url = url[0][item.id];
      } else {
        url = item.title;
      }
      const data = `${url}`;
      this.$store.commit('currentAttachment', data);
    },
  },
};
</script>

<style scoped>
.auth-error {
  margin: 5px;
  padding: 3px;
  color: #E91300;
}
.bottom {
  justify-content: space-between;
  align-items: center;
}
.forgot {
  margin-right: 20px;
}
.forgot:hover {
  text-decoration: underline;
  cursor: pointer;
  color: #e66465;
}
.list-item {
  font-size: 0.8em;
  color: blue;
  margin-bottom: 0 !important;
}
.flexcard {
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>
